// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* INCYIA auth — compact, optically centered stack */

.incyia-auth-solo {
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  margin: 0;
  padding: 48px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #f1f4fa;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  overflow-x: hidden;
  overflow-y: auto;
}

.incyia-auth-solo::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.45;
  background-image:
    linear-gradient(rgba(0, 20, 109, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 20, 109, 0.035) 1px, transparent 1px);
  background-size: 40px 40px;
}

.incyia-auth-topbar {
  position: absolute;
  top: 14px;
  right: 16px;
  z-index: 2;
}

.incyia-auth-top-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 10px;
  border-radius: 7px;
  border: none;
  background: transparent;
  color: #5b6b87;
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  width: auto !important;
}

.incyia-auth-top-btn:hover {
  background: #f7f9fd;
  color: #0b1e2d;
}

/* Full stack (card + links) is what gets centered */
.incyia-auth-stage {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 0 auto;
}

.incyia-auth-stage.is-wide {
  max-width: 420px;
}

.incyia-auth-card {
  width: 100%;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  padding: 22px 22px 20px;
  box-shadow: 0 14px 36px -24px rgba(0, 20, 109, 0.4);
  box-sizing: border-box;
}

.incyia-auth-mark {
  display: flex;
  justify-content: center;
  margin: 0 0 18px;
  padding-bottom: 2px;
}

.incyia-auth-logo {
  display: block;
  width: 64px;
  height: auto;
  max-height: 52px;
  object-fit: contain;
}

.incyia-auth-below {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.incyia-auth-card h1,
.incyia-auth-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  text-align: center;
  color: #0b1e2d;
}

.incyia-auth-sub {
  margin: 6px 0 16px;
  font-size: 12px;
  color: #5b6b87;
  line-height: 1.45;
  text-align: center;
}

.incyia-auth-or {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  color: #8b99b4;
  font-size: 12px;
}

.incyia-auth-or::before,
.incyia-auth-or::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: #dee4f0;
}

.incyia-auth-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.incyia-auth-field + .incyia-auth-field {
  margin-top: 10px;
}

.incyia-auth-label {
  font-size: 12px;
  font-weight: 600;
  color: #0b1e2d;
  display: flex;
  align-items: center;
  gap: 3px;
  font-family: Lato, sans-serif;
}

.incyia-auth-req {
  color: #d14a3e;
  font-size: 11px;
}

.incyia-auth-help {
  font-size: 11px;
  color: #8b99b4;
  line-height: 1.4;
}

.incyia-auth-inp {
  height: 36px;
  width: 100%;
  border: 1px solid #dee4f0;
  border-radius: 7px;
  padding: 0 11px;
  background: #fff;
  font-family: Lato, sans-serif;
  font-size: 13px;
  color: #0b1e2d;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.incyia-auth-inp:hover {
  border-color: #8b99b4;
}

.incyia-auth-inp:focus {
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);
}

.incyia-auth-inp::placeholder {
  color: #8b99b4;
  font-size: 12.5px;
}

.incyia-auth-pw-wrap {
  position: relative;
  display: block;
}

.incyia-auth-pw-wrap .incyia-auth-inp {
  padding-right: 34px;
}

.incyia-auth-pw-eye {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px !important;
  height: 24px;
  border: none;
  border-radius: 5px;
  display: grid;
  place-items: center;
  color: #8b99b4;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.incyia-auth-pw-eye:hover {
  background: #eaeff7;
  color: #0b1e2d;
}

.incyia-auth-pw-eye svg {
  width: 13px;
  height: 13px;
}

.incyia-auth-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.incyia-auth-check {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #5b6b87;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.incyia-auth-check input {
  width: 13px;
  height: 13px;
  accent-color: #00146d;
  cursor: pointer;
}

.incyia-auth-link {
  background: none;
  border: none;
  padding: 0;
  color: #00146d;
  font-weight: 600;
  font-size: 12px;
  font-family: Lato, sans-serif;
  cursor: pointer;
  width: auto !important;
  border-bottom: 1px solid transparent;
}

.incyia-auth-link:hover {
  color: #0e8271;
  border-bottom-color: currentColor;
}

.incyia-auth-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100% !important;
  height: 38px;
  margin-top: 14px;
  border: none;
  border-radius: 7px;
  background: #00146d;
  color: #fff;
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 20, 109, 0.3);
}

.incyia-auth-submit:hover:not(:disabled) {
  background: #1b2f8f;
}

.incyia-auth-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.incyia-auth-submit.is-ghost {
  background: #fff;
  color: #0b1e2d;
  border: 1px solid #dee4f0;
  box-shadow: none;
}

.incyia-auth-submit.is-ghost:hover:not(:disabled) {
  background: #f7f9fd;
  border-color: #8b99b4;
}

.incyia-auth-sso {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100% !important;
  height: 36px;
  border-radius: 7px;
  border: 1px solid #dee4f0;
  background: #fff;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.incyia-auth-sso:hover {
  background: #f7f9fd;
  border-color: #8b99b4;
}

.incyia-auth-trail {
  display: flex;
  gap: 7px;
  align-items: flex-start;
  margin-top: 12px;
  font-size: 11px;
  color: #5b6b87;
  line-height: 1.4;
}

.incyia-auth-trail svg {
  width: 12px;
  height: 12px;
  flex: none;
  margin-top: 1px;
  color: #8b99b4;
}

.incyia-auth-foot {
  margin: 0;
  font-size: 12px;
  color: #5b6b87;
  text-align: center;
  line-height: 1.4;
}

.incyia-auth-tag {
  margin: 0;
  font-size: 11px;
  color: #8b99b4;
  text-align: center;
}

.incyia-auth-back {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  margin-bottom: 12px;
  width: auto !important;
}

.incyia-auth-back svg {
  width: 11px;
  height: 11px;
}

.incyia-auth-error {
  margin: 0 0 10px;
  padding: 9px 11px;
  border-radius: 7px;
  background: #fae6e3;
  border: 1px solid #f0c9c3;
  color: #96271b;
  font-size: 12px;
  line-height: 1.4;
  text-align: left;
}

.incyia-auth-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.incyia-auth-grid .incyia-auth-field {
  margin-top: 0;
}

.incyia-auth-grid .incyia-auth-field--span {
  grid-column: 1 / -1;
}

.incyia-auth-pw-meter {
  display: flex;
  gap: 4px;
  margin-top: 7px;
}

.incyia-auth-pw-meter span {
  flex: 1 1;
  height: 3px;
  border-radius: 99px;
  background: #eaeff7;
}

.incyia-auth-pw-meter.s1 span:nth-child(1) {
  background: #d14a3e;
}

.incyia-auth-pw-meter.s2 span:nth-child(-n + 2) {
  background: #e6a817;
}

.incyia-auth-pw-meter.s3 span:nth-child(-n + 3) {
  background: #3b76d8;
}

.incyia-auth-pw-meter.s4 span {
  background: #0d9b87;
}

.incyia-auth-pw-rules {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  margin-top: 7px;
}

.incyia-auth-pw-rules span {
  font-size: 10.5px;
  color: #8b99b4;
  display: flex;
  align-items: center;
  gap: 4px;
}

.incyia-auth-pw-rules span::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 99px;
  background: currentColor;
}

.incyia-auth-pw-rules span.is-ok {
  color: #0e8271;
}

.incyia-auth-ok {
  width: 36px;
  height: 36px;
  border-radius: 99px;
  display: grid;
  place-items: center;
  margin: 0 auto 12px;
  background: #e2f7f2;
  color: #0e8271;
}

.incyia-auth-ok svg {
  width: 16px;
  height: 16px;
}

.incyia-auth-help-box {
  background: #f7f9fd;
  border: 1px solid #dee4f0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 11.5px;
  color: #5b6b87;
  text-align: left;
}

.incyia-auth-help-box b {
  color: #0b1e2d;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}

.incyia-auth-help-box ul {
  margin: 0;
  padding-left: 15px;
  line-height: 1.65;
}

.incyia-auth-center-link {
  display: block;
  margin: 10px auto 0;
  text-align: center;
}

@media (max-width: 560px) {
  .incyia-auth-solo {
    padding: 56px 14px 32px;
    justify-content: center;
  }

  .incyia-auth-stage,
  .incyia-auth-stage.is-wide {
    max-width: 100%;
  }

  .incyia-auth-card {
    padding: 20px 18px 18px;
  }

  .incyia-auth-logo {
    width: 58px;
    max-height: 48px;
  }

  .incyia-auth-mark {
    margin-bottom: 16px;
  }

  .incyia-auth-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/auth/auth.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;wEAEsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* INCYIA auth — compact, optically centered stack */\n\n.incyia-auth-solo {\n  box-sizing: border-box;\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  margin: 0;\n  padding: 48px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: #f1f4fa;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.incyia-auth-solo::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.45;\n  background-image:\n    linear-gradient(rgba(0, 20, 109, 0.035) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(0, 20, 109, 0.035) 1px, transparent 1px);\n  background-size: 40px 40px;\n}\n\n.incyia-auth-topbar {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  z-index: 2;\n}\n\n.incyia-auth-top-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 7px;\n  border: none;\n  background: transparent;\n  color: #5b6b87;\n  font-family: Lato, sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  width: auto !important;\n}\n\n.incyia-auth-top-btn:hover {\n  background: #f7f9fd;\n  color: #0b1e2d;\n}\n\n/* Full stack (card + links) is what gets centered */\n.incyia-auth-stage {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 340px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 0 0 auto;\n}\n\n.incyia-auth-stage.is-wide {\n  max-width: 420px;\n}\n\n.incyia-auth-card {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  padding: 22px 22px 20px;\n  box-shadow: 0 14px 36px -24px rgba(0, 20, 109, 0.4);\n  box-sizing: border-box;\n}\n\n.incyia-auth-mark {\n  display: flex;\n  justify-content: center;\n  margin: 0 0 18px;\n  padding-bottom: 2px;\n}\n\n.incyia-auth-logo {\n  display: block;\n  width: 64px;\n  height: auto;\n  max-height: 52px;\n  object-fit: contain;\n}\n\n.incyia-auth-below {\n  margin-top: 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.incyia-auth-card h1,\n.incyia-auth-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  text-align: center;\n  color: #0b1e2d;\n}\n\n.incyia-auth-sub {\n  margin: 6px 0 16px;\n  font-size: 12px;\n  color: #5b6b87;\n  line-height: 1.45;\n  text-align: center;\n}\n\n.incyia-auth-or {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 12px 0;\n  color: #8b99b4;\n  font-size: 12px;\n}\n\n.incyia-auth-or::before,\n.incyia-auth-or::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #dee4f0;\n}\n\n.incyia-auth-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.incyia-auth-field + .incyia-auth-field {\n  margin-top: 10px;\n}\n\n.incyia-auth-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0b1e2d;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-auth-req {\n  color: #d14a3e;\n  font-size: 11px;\n}\n\n.incyia-auth-help {\n  font-size: 11px;\n  color: #8b99b4;\n  line-height: 1.4;\n}\n\n.incyia-auth-inp {\n  height: 36px;\n  width: 100%;\n  border: 1px solid #dee4f0;\n  border-radius: 7px;\n  padding: 0 11px;\n  background: #fff;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  color: #0b1e2d;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.incyia-auth-inp:hover {\n  border-color: #8b99b4;\n}\n\n.incyia-auth-inp:focus {\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);\n}\n\n.incyia-auth-inp::placeholder {\n  color: #8b99b4;\n  font-size: 12.5px;\n}\n\n.incyia-auth-pw-wrap {\n  position: relative;\n  display: block;\n}\n\n.incyia-auth-pw-wrap .incyia-auth-inp {\n  padding-right: 34px;\n}\n\n.incyia-auth-pw-eye {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px !important;\n  height: 24px;\n  border: none;\n  border-radius: 5px;\n  display: grid;\n  place-items: center;\n  color: #8b99b4;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n}\n\n.incyia-auth-pw-eye:hover {\n  background: #eaeff7;\n  color: #0b1e2d;\n}\n\n.incyia-auth-pw-eye svg {\n  width: 13px;\n  height: 13px;\n}\n\n.incyia-auth-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.incyia-auth-check {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #5b6b87;\n  cursor: pointer;\n  user-select: none;\n}\n\n.incyia-auth-check input {\n  width: 13px;\n  height: 13px;\n  accent-color: #00146d;\n  cursor: pointer;\n}\n\n.incyia-auth-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #00146d;\n  font-weight: 600;\n  font-size: 12px;\n  font-family: Lato, sans-serif;\n  cursor: pointer;\n  width: auto !important;\n  border-bottom: 1px solid transparent;\n}\n\n.incyia-auth-link:hover {\n  color: #0e8271;\n  border-bottom-color: currentColor;\n}\n\n.incyia-auth-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100% !important;\n  height: 38px;\n  margin-top: 14px;\n  border: none;\n  border-radius: 7px;\n  background: #00146d;\n  color: #fff;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 20, 109, 0.3);\n}\n\n.incyia-auth-submit:hover:not(:disabled) {\n  background: #1b2f8f;\n}\n\n.incyia-auth-submit:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.incyia-auth-submit.is-ghost {\n  background: #fff;\n  color: #0b1e2d;\n  border: 1px solid #dee4f0;\n  box-shadow: none;\n}\n\n.incyia-auth-submit.is-ghost:hover:not(:disabled) {\n  background: #f7f9fd;\n  border-color: #8b99b4;\n}\n\n.incyia-auth-sso {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100% !important;\n  height: 36px;\n  border-radius: 7px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.incyia-auth-sso:hover {\n  background: #f7f9fd;\n  border-color: #8b99b4;\n}\n\n.incyia-auth-trail {\n  display: flex;\n  gap: 7px;\n  align-items: flex-start;\n  margin-top: 12px;\n  font-size: 11px;\n  color: #5b6b87;\n  line-height: 1.4;\n}\n\n.incyia-auth-trail svg {\n  width: 12px;\n  height: 12px;\n  flex: none;\n  margin-top: 1px;\n  color: #8b99b4;\n}\n\n.incyia-auth-foot {\n  margin: 0;\n  font-size: 12px;\n  color: #5b6b87;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.incyia-auth-tag {\n  margin: 0;\n  font-size: 11px;\n  color: #8b99b4;\n  text-align: center;\n}\n\n.incyia-auth-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  margin-bottom: 12px;\n  width: auto !important;\n}\n\n.incyia-auth-back svg {\n  width: 11px;\n  height: 11px;\n}\n\n.incyia-auth-error {\n  margin: 0 0 10px;\n  padding: 9px 11px;\n  border-radius: 7px;\n  background: #fae6e3;\n  border: 1px solid #f0c9c3;\n  color: #96271b;\n  font-size: 12px;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.incyia-auth-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.incyia-auth-grid .incyia-auth-field {\n  margin-top: 0;\n}\n\n.incyia-auth-grid .incyia-auth-field--span {\n  grid-column: 1 / -1;\n}\n\n.incyia-auth-pw-meter {\n  display: flex;\n  gap: 4px;\n  margin-top: 7px;\n}\n\n.incyia-auth-pw-meter span {\n  flex: 1;\n  height: 3px;\n  border-radius: 99px;\n  background: #eaeff7;\n}\n\n.incyia-auth-pw-meter.s1 span:nth-child(1) {\n  background: #d14a3e;\n}\n\n.incyia-auth-pw-meter.s2 span:nth-child(-n + 2) {\n  background: #e6a817;\n}\n\n.incyia-auth-pw-meter.s3 span:nth-child(-n + 3) {\n  background: #3b76d8;\n}\n\n.incyia-auth-pw-meter.s4 span {\n  background: #0d9b87;\n}\n\n.incyia-auth-pw-rules {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 10px;\n  margin-top: 7px;\n}\n\n.incyia-auth-pw-rules span {\n  font-size: 10.5px;\n  color: #8b99b4;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.incyia-auth-pw-rules span::before {\n  content: '';\n  width: 4px;\n  height: 4px;\n  border-radius: 99px;\n  background: currentColor;\n}\n\n.incyia-auth-pw-rules span.is-ok {\n  color: #0e8271;\n}\n\n.incyia-auth-ok {\n  width: 36px;\n  height: 36px;\n  border-radius: 99px;\n  display: grid;\n  place-items: center;\n  margin: 0 auto 12px;\n  background: #e2f7f2;\n  color: #0e8271;\n}\n\n.incyia-auth-ok svg {\n  width: 16px;\n  height: 16px;\n}\n\n.incyia-auth-help-box {\n  background: #f7f9fd;\n  border: 1px solid #dee4f0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 11.5px;\n  color: #5b6b87;\n  text-align: left;\n}\n\n.incyia-auth-help-box b {\n  color: #0b1e2d;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.incyia-auth-help-box ul {\n  margin: 0;\n  padding-left: 15px;\n  line-height: 1.65;\n}\n\n.incyia-auth-center-link {\n  display: block;\n  margin: 10px auto 0;\n  text-align: center;\n}\n\n@media (max-width: 560px) {\n  .incyia-auth-solo {\n    padding: 56px 14px 32px;\n    justify-content: center;\n  }\n\n  .incyia-auth-stage,\n  .incyia-auth-stage.is-wide {\n    max-width: 100%;\n  }\n\n  .incyia-auth-card {\n    padding: 20px 18px 18px;\n  }\n\n  .incyia-auth-logo {\n    width: 58px;\n    max-height: 48px;\n  }\n\n  .incyia-auth-mark {\n    margin-bottom: 16px;\n  }\n\n  .incyia-auth-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
